export default {
  debug: false
};